import React from "react";

import UserCabinedMode from "../discontinued/UserCabinedMode";
import UserContentGated from "../discontinued/UserContentGated";
import { getUserIsGated, getUserIsCabinedMode, getUserIsMinor } from "../../utils/Utils";
import { LegalContent } from "./LegalContent";
import { GAME_TITLE } from "../../constants/GameTitle";
import { getMessage } from "../common/message/Message";
import RedeemError from '../../components/redeem/RedeemError';
import { LoginWrapper } from '../../components';

export const withContentGated = (gameId) => Component =>
({...props}) => {
    const { configState = {}, userState = {}, legalState = {}, messages = {} } = props; //eslint-disable-line react/prop-types
    const { accountInfo = {}, hasEsportEntitlement } = userState;
    if (!userState.isLoggedIn && !legalState.isRqueiredCorrective) {
        return <LoginWrapper productName="fortnite" />;
    }
    if (hasEsportEntitlement === false && gameId === GAME_TITLE.FORTNITE && !legalState.isRqueiredCorrective) {
        const supportSiteName = getMessage(messages, 'epic.common.support_site');
        const supportUrl = configState.supportUrl;
        return (
            <RedeemError
                supportName={supportSiteName}
                supportUrl={supportUrl}
            />
        );
    }
    if (getUserIsGated(accountInfo, gameId)) {
        return <UserContentGated />;
    }
    if (getUserIsCabinedMode(accountInfo) || legalState.isRqueiredCorrective) {
        return <UserCabinedMode configState={configState} />;
    }
    if (getUserIsMinor(accountInfo)
        && !legalState.form.guardianEmail
        && (gameId === GAME_TITLE.FORTNITE)) {
        return (
            <LegalContent
                messages={messages}
                legalState={legalState}
                gameId={gameId} />
        );
    }
    return (
        <div>
            <Component {...props} isMinor={getUserIsMinor(accountInfo)} />
        </div>
    );
};
